import { uploadImage } from "./imageUploadUtils";

export const createFileChangeHandler = (setUploading, base64Key, createFn, fetchFn) => {
    return async (e) => {
        const file = e.target.files[0];
        if (file) {
            setUploading(true);
            try {
                await uploadImage(file, base64Key, createFn, fetchFn);
            } catch (error) {
                console.error(`Error saving ${base64Key}:`, error);
            } finally {
                setUploading(false);
            }
        }
    };
};

export const triggerFileInput = (fileInputRef) => {
    if (fileInputRef.current) {
        fileInputRef.current.click();
    }
};
